<ama-ng-app-store-offices-list
  [headerTemplate]="header"
  [itemTemplate]="office"
  [offices]="offices"
  class="d-flex flex-column flex-grow-1"
  >
  <ng-template #header let-offices>
    <input (change)="onSelectAllCheckboxChange()"
      [(ngModel)]=selectAllChecked
      id="select-all-checkbox"
      [indeterminate]="offices | indeterminateState: 'isDeployed'"
      class="form-check-input ps-2"
      [disabled]="allDisabled || (deploymentService.isDeploymentAllowedForSelectedEntity$ | async) === false"
      [ngbTooltip]="deploymentService.selectAllDisabledReason$(allDisabled) | async"
      placement="top"
      container="body"
      type="checkbox"
      value=""/>
      <label for="select-all-checkbox" class="form-check-label">
        {{ (deploymentService.selectedDeploymentLevelCategory$ | async)?.selectAllLabel }}
      </label>
    </ng-template>

    <ng-template #office let-office>
      <input (click)="onSelectOfficeDeploymentCheckboxChange(office)"
        [id]="'checkbox-' + office.actor.actorName"
        class="col-1 form-check-input me-2 my-0 ms-2"
        type="checkbox"
        aria-label="Deploy"
               [disabled]="(office | isDeploymentDisabled)
                       || (deploymentService.isDeploymentAllowedForGivenEntity$(office) | async) === false"
        [checked]="office | isEntityDeployed"
        [ngbTooltip]="deploymentService.deploymentDisabledReason$(office) | async"
        placement="top"
        container="body"
        />
        <label [for]="'checkbox-' + office.actor.actorName"
          class="form-check-label overflow-hidden fixed-width"
               [class.disabled]="(office | isDeploymentDisabled)
                       || (deploymentService.isDeploymentAllowedForGivenEntity$(office) | async) === false"
          [id]="'label-' + office.actor.actorName">
          <span>{{ office.actor.actorName }}</span>
        </label>
        @if ((office.tag | statusStyle) !== '') {
          <span
            aria-hidden="true"
                class="col-1 badge df-badge-dot {{ office.tag | statusStyle }} me-1 p-2
                                    text-align-left fixed-width"
            [id]="'item-badge-' + office.actor.actorName"
            >
            {{ office.tag | statusLabel }}
          </span>
        }
        @if (canDeployOrgOgu && ((office | showExclusion: false ))) {
          <input class="form-check-input mx-1 ms-2 flex-shrink-0 my-0"
            type="checkbox"
            [checked]="office | isEntityExcluded"
                   [disabled]="(office | isExclusionDisabled)
                           || (deploymentService.isDeploymentAllowedForGivenEntity$(office) | async) === false"
            [ngbTooltip]="deploymentService.exclusionDisabledReason$(office)| async"
            placement="top"
            container="body"
            [id]="'exclude-' + office.actor.actorName"
            (click)="onSelectOfficeExclusionsCheckboxChange(office)"
            aria-label="Exclude"
            />
            <span class="ms-1 flex-shrink-0" aria-hidden="true"
                  [class.disabled]="(office | isExclusionDisabled)
                          || (deploymentService.isDeploymentAllowedForGivenEntity$(office) | async) === false">Exclude</span>
          }
          <div class="col flex-grow-1 flex-shrink-1"></div>
        </ng-template>
      </ama-ng-app-store-offices-list>
